import React,{useEffect, useState} from "react";
import useTable from "../../components/table/useTable";
import { getLocalStorage } from "../../store/config/storage";
import {get} from '../../store/config/register';
import TableFooter from "../../components/table/TableFooter";
import {FiX,FiEdit2} from 'react-icons/fi';
import { useHistory,useParams } from "react-router-dom";
import { toast } from 'react-toastify';


export default function PesquisaAcompanhante(props) {

    const [acompanhantes,setAcompanhantes]=useState([]);
    const [page, setPage] = useState(1);
    const { slice, range } = useTable(acompanhantes, page, 10);
    const history = useHistory();
    const [reserva,setReserva] =useState({})

    const search = props.location.search;
    const params = new URLSearchParams(search);
    let id=0;
    let idVisita=0;

    if(params !== undefined){
      if(params.get("Visitante")!==null){
        id =params.get("Visitante");

      }

      if(params.get("Visita")!==null){
        idVisita =params.get("Visita");
      }
    }

useEffect(() =>{
    getReserva();
},[])

    async function getReserva() {
      let res =  getLocalStorage('reserva');

      if(res  !== undefined && res !== null) {
        let item =JSON.parse(res)
        setReserva(item)
        await getAcompanhantes(item.id);
      }
    }
   async function getAcompanhantes(idReserva) {
     const acomps =   await get('/Acompanhante/v1/'+idReserva);

     if(acomps !== null){

        setAcompanhantes(acomps);
     }
    }

    function renderForm(){
        return (
            <div className="form">
                <br/>
             <div id="botao">
                  <button  className="btn btn-primary ml-2" onClick={ async e => 
                  {
                    if(idVisita !== 0){
                        history.push('/Hospedes/Pesquisa/'+id)
                    }
                    else {
                       toast.warning('Salve o hospede, para adicionar acompanhante');
                    }
                }
                }
                  >
                    Incluir Acompanhante
                  </button>
            </div>
                <hr />
                {renderTable()}
            </div>
        );
    }

    function renderTable(){
        return (
            <div className='tabela'>
            <table>
                <thead>
                    <tr>
                    <th scope="col">Nome</th>
                    </tr>
                </thead>
                <tbody>
                {slice === undefined ? null :slice.map((item, index)=>{
                    return (
                <tr key={index}>
                  <td data-label="Nome">{item.nome}</td>
                <td  data-label="">
                  <button className="action" style={{backgroundColor: '#F99E08' ,marginRight: "20px" }} data-toggle="tooltip" data-placement="bottom" title="Editar" onClick={(e) => history.push('/Acompanhante/'+id+'/'+ item.idAcompanhante)} >
                    <FiEdit2 color="#FFF" size={17} />
                    </button>
                    <button className="action" style={{backgroundColor: '#ff0000', marginTop: "10px" }} data-toggle="tooltip" data-placement="bottom" title="Excluir Visitante"  onClick={async(e) => true } >
                    <FiX color="#FFF" size={17} />
                    </button>
                    </td>
                </tr>
                    );

                })}
                </tbody>
            </table>
            <TableFooter range={range} slice={slice} setPage={setPage} page={page} />
        </div>
        );
    }

    return(
        <div>
            {renderForm()}
        </div>
    );
}